import { gql } from 'src/generated/gql';

export const GET_REQUEST_QUERY = gql(`
  query GetDropInClinicRequest($requestId: String!) {
    staff_getDropInClinicRequest(requestId: $requestId) {
      eventId
      patientId
      providerId
      status
    }
  }
`);
